<template>
  <v-container
    id="comercial-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <v-row>
      <v-col
        cols="12"
        lg="12"
        class="px-1"
      >
        <dashboard-filtro-datas
          :primeiro="enablePrimeiroDia"
          :ultimo="enableUltimoDia"
          :empresas="enableEmpresa"
          :supervisores="enableSupervisores"
          :url="link"
        />
        <br><br>
        <v-row>
          <v-col
            cols="12"
            sm="12"
            md="6"
            lg="4"
          >
            <v-container>
              <v-row>
                <v-col
                  id="componenteFaturamento"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="12"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :exibir-informacao="true"
                    :text="'Faturamento'"
                    :code-information="'140'"
                    :texto-information="textoFaturamento"
                    :componente-valor-coluna="true"
                    :style-object="styleObject"
                    :style-object2="styleObjectIcmsst"
                    :componente-valor="true"
                    :valor="valorFaturamento"
                    :valor2="valorIcmsst"
                    :padding="dynamicPaddingVendas1"
                    :width="width"
                    :loading="loadingFaturamento"
                    :valor-faturamento-icmsst="true"
                  />
                </v-col>
                <v-col
                  id="componenteFaturamento"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="12"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :exibir-informacao="true"
                    :text="'Devolução'"
                    :code-information="'342'"
                    :texto-information="textoDevolucao"
                    :style-object="styleObjectDevolucao"
                    :componente-valor="true"
                    :valor="valorDevolucao"
                    :padding="dynamicPaddingVendas1"
                    :width="width"
                    :exibir-icone="exibirIcone"
                    :link-detalhe="'/vendas3/detalhe-vendas3-devolucao'"
                    :loading="loadingDevolucao"
                  />
                </v-col>
                <v-col
                  id="componenteFaturamento"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="12"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :exibir-informacao="true"
                    :text="'Fatu. do Mês no Ano Anterior'"
                    :code-information="'371'"
                    :texto-information="textoFaturamentoAnteior"
                    :style-object="styleObject"
                    :style-object2="styleObjectIcmsst"
                    :componente-valor="true"
                    :valor="valorFaturamentoAnoAnterior"
                    :valor2="valorIcmsstAnoAnterior"
                    :padding="dynamicPaddingVendas1"
                    :width="width"
                    :loading="loadingFaturamentoAnoAnterior"
                    :valor-faturamento-icmsst="true"
                    :componente-valor-coluna="true"
                  />
                </v-col>
                <v-col
                  id="componenteDevolucao"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="12"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :exibir-informacao="true"
                    :text="'Devolução do Mês no Ano Anterior'"
                    :code-information="'343'"
                    :texto-information="textoDevolucaoAnteior"
                    :style-object="styleObjectDevolucao"
                    :componente-valor="true"
                    :valor="valorDevolucaoAnoAnterior"
                    :padding="dynamicPaddingVendas1"
                    :width="width"
                    :exibir-icone="exibirIcone"
                    :link-detalhe="'/vendas3/detalhe-vendas3-devolucao-ano-anterior'"
                    :loading="loadingDevolucaoAnoAnterior"
                  />
                </v-col>
                <v-col
                  id="componenteFaturamento"
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :exibir-informacao="true"
                    :text="'Acumulado Comparativo Faturamento'"
                    :code-information="'373'"
                    :texto-information="textoFaturamentoAcumulado"
                    :style-object="styleObject"
                    :componente-grafico="true"
                    :grafico-id="'myChart9'"
                    :dados-grafico="chartBarAcumuladoAnual"
                    :titulo-id="'myChart9'"
                    :padding="dynamicPaddingVendas2"
                    :width="width"
                    :loading="loadingFaturamentoAcumulado"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="8"
          >
            <v-row>
              <v-col
                id="componenteFaturamento"
                cols="12"
                sm="12"
                md="12"
                lg="12"
              >
                <v-card
                  id="cardDashbord"
                  class="mx-auto"
                  outlined
                  :max-width="width"
                >
                  <div class="card-header-dashbord">
                    <v-row>
                      <v-col
                        cols="12"
                        sm="10"
                        md="10"
                        lg="10"
                        class="d-flex flex-wrap"
                      >
                        Comparativo Faturamento
                      </v-col>
                      <v-col
                        cols="12"
                        sm="2"
                        md="2"
                        lg="2"
                        class="d-flex justify-end"
                      >
                        <v-tooltip top>
                          <template
                            v-slot:activator="{ on, attrs }"
                          >
                            <v-icon
                              id="iconInformationFatxMetaComercial4"
                              class="text-left"
                              v-bind="attrs"
                              v-on="on"
                              @mouseover="enableTexto('372')"
                            >
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <div
                            v-if="codigo === '372'"
                            v-html="textoOrientacao"
                          />
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </div>
                  <v-card-actions>
                    <v-row>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        lg="12"
                      >
                        <div
                          v-if="loadingFaturamentoComparativo"
                          id="carregaDados"
                          class="text-center"
                          :style="styleObject"
                        >
                          <v-icon
                            light
                            class="custom-loader"
                            :style="styleObject"
                          >
                            mdi-cached
                          </v-icon>
                          Carregando Dados...
                        </div>
                        <div
                          v-else-if="error"
                          class="alert alert-danger"
                        >
                          {{ error }}
                        </div>
                        <canvas
                          id="myChart7"
                          width="180"
                          height="70"
                        />
                        <br>
                        <div
                          v-if="exibirLegenda"
                          id="legendaDistribuicaoCliente"
                          class="text-center px-3"
                        >
                          <v-row
                            align="center"
                            class="ma-0"
                            no-gutters
                          >
                            <v-col
                              md="12"
                              offset-md="1"
                            >
                              <v-row>
                                <div
                                  v-for="status in legendaGrafico"
                                  :key="status.status"
                                >
                                  <v-avatar
                                    class="mr-1"
                                    :color="status.cor"
                                    size="12"
                                  />
                                  <span class="mr-3 font-weight-light">{{ status.status }}</span>
                                </div>
                              </v-row>
                            </v-col>
                          </v-row>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-col>
              <v-col
                id="componenteFaturamento"
                cols="12"
                sm="12"
                md="12"
                lg="12"
              >
                <v-card
                  id="cardDashbord"
                  class="mx-auto"
                  outlined
                  :max-width="width"
                >
                  <div class="card-header-dashbord">
                    <v-row>
                      <v-col
                        cols="12"
                        sm="10"
                        md="10"
                        lg="10"
                        class="d-flex flex-wrap"
                      >
                        Comparativo Preço Médio
                      </v-col>
                      <v-col
                        cols="12"
                        sm="2"
                        md="2"
                        lg="2"
                        class="d-flex justify-end"
                      >
                        <v-tooltip
                          top
                          max-width="400"
                          width="400"
                        >
                          <template
                            v-slot:activator="{ on, attrs }"
                          >
                            <v-icon
                              id="iconInformationFatxMetaComercial4"
                              class="text-left"
                              v-bind="attrs"
                              v-on="on"
                              @mouseover="enableTexto('374')"
                            >
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <div
                            v-if="carregandoTooltip"
                            class="d-flex align-center"
                          >
                            <v-progress-circular
                              indeterminate
                              size="18"
                              width="2"
                              class="mr-2"
                            />
                            Carregando Orientação...
                          </div>
                          <div
                            v-if="codigo === '374' && !carregandoTooltip"
                            v-html="textoOrientacao"
                          />
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </div>
                  <v-card-actions>
                    <v-row>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        lg="12"
                      >
                        <div
                          v-if="loadingPrecoMedioComparativo"
                          id="carregaDados"
                          class="text-center"
                          :style="styleObject"
                        >
                          <v-icon
                            light
                            class="custom-loader"
                            :style="styleObject"
                          >
                            mdi-cached
                          </v-icon>
                          Carregando Dados...
                        </div>
                        <div
                          v-else-if="error"
                          class="alert alert-danger"
                        >
                          {{ error }}
                        </div>
                        <canvas
                          id="precoMedioMesesAnteriores"
                          width="180"
                          height="70"
                        />
                        <br>
                        <div
                          v-if="exibirLegenda2"
                          id="legendaDistribuicaoCliente"
                          class="text-center px-3"
                        >
                          <v-row
                            align="center"
                            class="ma-0"
                            no-gutters
                          >
                            <v-col
                              md="12"
                              offset-md="1"
                            >
                              <v-row>
                                <div
                                  v-for="status in legendaGrafico"
                                  :key="status.status"
                                >
                                  <v-avatar
                                    class="mr-1"
                                    :color="status.cor"
                                    size="12"
                                  />
                                  <span class="mr-3 font-weight-light">{{ status.status }}</span>
                                </div>
                              </v-row>
                            </v-col>
                          </v-row>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            id="componenteFaturamento"
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <v-card
              id="cardDashbord"
              class="mx-auto"
              outlined
              :max-width="width"
            >
              <div class="card-header-dashbord">
                <v-row>
                  <v-col
                    cols="12"
                    sm="10"
                    md="10"
                    lg="10"
                    class="d-flex flex-wrap"
                  >
                    Como está o acumulado do ano até o mês atual?
                  </v-col>
                  <v-col
                    cols="12"
                    sm="2"
                    md="2"
                    lg="2"
                    class="d-flex justify-end"
                  >
                    <v-tooltip
                      top
                      max-width="400"
                      width="400"
                    >
                      <template
                        v-slot:activator="{ on, attrs }"
                      >
                        <v-icon
                          id="iconVendas3"
                          class="text-left"
                          v-bind="attrs"
                          v-on="on"
                          @mouseover="enableTexto('141')"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <div
                        v-if="carregandoTooltip"
                        class="d-flex align-center"
                      >
                        <v-progress-circular
                          indeterminate
                          size="18"
                          width="2"
                          class="mr-2"
                        />
                        Carregando Orientação...
                      </div>
                      <div
                        v-if="codigo === '141' && !carregandoTooltip"
                        v-html="textoOrientacao"
                      />
                    </v-tooltip>
                  </v-col>
                </v-row>
              </div>
              <v-card-actions>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="12"
                  >
                    <dashboard-vendas-meses-do-ano />
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <v-row>
              <v-col
                id="componenteFaturamento"
                cols="12"
                sm="12"
                md="6"
                lg="6"
              >
                <v-card
                  id="cardDashbord"
                  class="mx-auto"
                  outlined
                  :max-width="width"
                >
                  <div class="card-header-dashbord">
                    <v-row>
                      <v-col
                        cols="12"
                        sm="10"
                        md="10"
                        lg="10"
                        class="d-flex flex-wrap"
                      >
                        Quais foram os principais clientes?
                      </v-col>
                      <v-col
                        cols="12"
                        sm="2"
                        md="2"
                        lg="2"
                        class="d-flex justify-end"
                      >
                        <v-tooltip
                          top
                          max-width="400"
                          width="400"
                        >
                          <template
                            v-slot:activator="{ on, attrs }"
                          >
                            <v-icon
                              id="iconVendas3"
                              class="text-left"
                              v-bind="attrs"
                              v-on="on"
                              @mouseover="enableTexto('142')"
                            >
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <div
                            v-if="carregandoTooltip"
                            class="d-flex align-center"
                          >
                            <v-progress-circular
                              indeterminate
                              size="18"
                              width="2"
                              class="mr-2"
                            />
                            Carregando Orientação...
                          </div>
                          <div
                            v-if="codigo === '142' && !carregandoTooltip"
                            v-html="textoOrientacao"
                          />
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </div>
                  <v-card-actions>
                    <show-faturamento-principais-clientes-vendas />
                  </v-card-actions>
                </v-card>
              </v-col>
              <v-col
                id="componenteFaturamento"
                cols="12"
                sm="12"
                md="6"
                lg="6"
              >
                <v-card
                  id="cardDashbord"
                  class="mx-auto"
                  outlined
                  :max-width="width"
                >
                  <div class="card-header-dashbord">
                    <v-row>
                      <v-col
                        cols="12"
                        sm="10"
                        md="10"
                        lg="10"
                        class="d-flex flex-wrap"
                      >
                        Como está o faturamento dos meus grupos de itens?
                      </v-col>
                      <v-col
                        cols="12"
                        sm="2"
                        md="2"
                        lg="2"
                        class="d-flex justify-end"
                      >
                        <v-tooltip
                          top
                          max-width="400"
                          width="400"
                        >
                          <template
                            v-slot:activator="{ on, attrs }"
                          >
                            <v-icon
                              id="iconVendas3"
                              class="text-left"
                              v-bind="attrs"
                              v-on="on"
                              @mouseover="enableTexto('338')"
                            >
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <div
                            v-if="carregandoTooltip"
                            class="d-flex align-center"
                          >
                            <v-progress-circular
                              indeterminate
                              size="18"
                              width="2"
                              class="mr-2"
                            />
                            Carregando Orientação...
                          </div>
                          <div
                            v-if="codigo === '338' && !carregandoTooltip"
                            v-html="textoOrientacao"
                          />
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </div>
                  <v-card-actions>
                    <show-faturamento-grupos-produtos-vendas />
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            id="componenteFaturamento"
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <v-card
              id="cardDashbord"
              class="mx-auto"
              outlined
              :max-width="width"
            >
              <div class="card-header-dashbord">
                <v-row>
                  <v-col
                    cols="12"
                    sm="10"
                    md="10"
                    lg="10"
                    class="d-flex flex-wrap"
                  >
                    Qual minha evolução de vendas?
                  </v-col>
                  <v-col
                    cols="12"
                    sm="2"
                    md="2"
                    lg="2"
                    class="d-flex justify-end"
                  >
                    <v-tooltip
                      top
                      max-width="400"
                      width="400"
                    >
                      <template
                        v-slot:activator="{ on, attrs }"
                      >
                        <v-icon
                          id="iconVendas3"
                          class="text-left"
                          v-bind="attrs"
                          v-on="on"
                          @mouseover="enableTexto('144')"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <div
                        v-if="carregandoTooltip"
                        class="d-flex align-center"
                      >
                        <v-progress-circular
                          indeterminate
                          size="18"
                          width="2"
                          class="mr-2"
                        />
                        Carregando Orientação...
                      </div>
                      <div
                        v-if="codigo === '144' && !carregandoTooltip"
                        v-html="textoOrientacao"
                      />
                    </v-tooltip>
                  </v-col>
                </v-row>
              </div>
              <v-card-actions>
                <show-evolucao-supervisor-vendas />
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            id="componenteFaturamento"
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <v-card
              id="cardDashbord"
              class="mx-auto"
              outlined
              :max-width="width"
            >
              <div class="card-header-dashbord">
                <v-row>
                  <v-col
                    cols="12"
                    sm="10"
                    md="10"
                    lg="10"
                    class="d-flex flex-wrap"
                  >
                    E referente a evolução em volume de venda?
                  </v-col>
                  <v-col
                    cols="12"
                    sm="2"
                    md="2"
                    lg="2"
                    class="d-flex justify-end"
                  >
                    <v-tooltip
                      top
                      max-width="400"
                      width="400"
                    >
                      <template
                        v-slot:activator="{ on, attrs }"
                      >
                        <v-icon
                          id="iconVendas3"
                          class="text-left"
                          v-bind="attrs"
                          v-on="on"
                          @mouseover="enableTexto('145')"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <div
                        v-if="carregandoTooltip"
                        class="d-flex align-center"
                      >
                        <v-progress-circular
                          indeterminate
                          size="18"
                          width="2"
                          class="mr-2"
                        />
                        Carregando Orientação...
                      </div>
                      <div
                        v-if="codigo === '145' && !carregandoTooltip"
                        v-html="textoOrientacao"
                      />
                    </v-tooltip>
                  </v-col>
                </v-row>
              </div>
              <v-card-actions>
                <show-evolucao-volume-vendas />
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import utils from '../../../../services/utils'
  import Permissao from '../../../../services/menu'
  import eventEmit from '../../components/core/EventoEmit'
  import Vendas3 from '../../../../services/vendas3'
  import Chart from 'chart.js'
  import ChartDataLabels from 'chartjs-plugin-datalabels'

  export default {
    name: 'PageComercial',
    emits: ['updateDadosClientesVendas', 'updateDatasVendas', 'atualizarTexto'],
    components: {
      DashboardCoreSnackbar: () => import('../../components/core/Snackbar'),
      DashboardFiltroDatas: () => import('../../components/core/FiltroDatas'),
      DashoardCardView: () => import('../../components/core/CardView'),
      DashboardVendasMesesDoAno: () => import('../../graficos/Vendas3/Vendas3MesesdoAno'),
      ShowFaturamentoPrincipaisClientesVendas: () => import('../../components/comercial/vendas3/FaturamentoPrincipaisClienteVendas3'),
      ShowFaturamentoGruposProdutosVendas: () => import('../../components/comercial/vendas3/FaturamentoProdutosVendas3'),
      ShowEvolucaoSupervisorVendas: () => import('../../components/comercial/vendas3/FaturamentoEvolucaoSupervisorVendas3PrecoMedio'),
      ShowEvolucaoVolumeVendas: () => import('../../components/comercial/vendas3/FaturamentoEvolucaoVolumeVendas3'),
    },
    mixins: [utils],
    data: () => ({
      appOnline: navigator.onLine,
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      styleObject: {
        color: localStorage.corPrimaria,
      },
      styleObjectIcmsst: {
        color: '#7da1ce',
      },
      styleObjectDevolucao: {
        color: '#C62828',
      },
      usuarioIdentificado: false,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      date: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      dateFormatted: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      select: [],
      empresa: [],
      supervisor: [],
      vendedores: [],
      areas: [],
      redes: [],
      receita: [],
      segmento: [],
      textoFaturamento: '',
      textoFatAcumulado: '',
      textoPrincipaisClientes: '',
      textoFatGrupoItens: '',
      textoFatEvolucaoVendas: '',
      textoVolumeEvolucaoVendas: '',
      textoFaturamentoAnteior: '',
      textoCompativoFaturamento: '',
      textoFaturamentoAcumulado: '',
      textoComparativoPrecoMedio: '',
      textoDevolucao: '',
      textoDevolucaoAnteior: '',
      codigo: 0,
      orientacao: [],
      codigoIds: ['140', '141', '142', '338', '144', '145', '315', '317', '342', '343', '371', '372', '373', '374'],
      permissaoVenda: '',
      enableFatPrinCliente: false,
      enableEvolucaoVendas: false,
      paginaEnable: false,
      enablePrimeiroDia: true,
      enableUltimoDia: true,
      enableEmpresa: true,
      enableSupervisores: false,
      exibirIcone: true,
      link: window.location.href,
      valorFaturamento: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorIcmsst: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorFaturamentoAnoAnterior: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorIcmsstAnoAnterior: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorDevolucao: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorDevolucaoAnoAnterior: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      legendaGrafico: [
        { cor: '#ed934f', status: 'Variação Anual de Faturamento' },
        { cor: '#cadaed', status: 'Faturamento Ano Anterior' },
        { cor: '#4780b8', status: 'Faturamento Corrente' },
      ],
      chartBarLinha: {},
      chartBarAcumuladoAnual: {},
      chartBarAcumuladoMensal: {},
      legendaGraficoMensal: [
        { cor: '#cadaed', status: 'Faturamento Ano Anterior' },
        { cor: '#4780b8', status: 'Faturamento Corrente' },
      ],
      chartBarLinhaPrecoMedio: {},
      legendaGraficoPrecoMedio: [
        { cor: '#ed934f', status: 'Variação Preço Médio' },
        { cor: '#cadaed', status: 'Preço Médio Ano Anterior' },
        { cor: '#4780b8', status: 'Preço Médio Corrente' },
      ],
      dynamicPaddingTitulo: '',
      dynamicPaddingVendas1: '',
      dynamicPaddingVendas2: '',
      dynamicPaddingVendas3: '',
      dynamicPaddingVendas4: '',
      dynamicPaddingVendas5: '',
      dynamicPaddingVendas6: '',
      width: '',
      loadingFaturamento: false,
      loadingDevolucao: false,
      loadingFaturamentoAnoAnterior: false,
      loadingDevolucaoAnoAnterior: false,
      loadingFaturamentoAcumulado: false,
      loadingFaturamentoComparativo: false,
      loadingPrecoMedioComparativo: false,
      exibirLegenda: false,
      exibirLegenda2: false,
      error: null,
      textoOrientacao: '',
      carregandoTooltip: false,
      codigoAtual: null,
    }),

    computed: {
      computedDateFormatted () {
        return this.formatDate(this.date)
      },

      computedPrimeiroDia () {
        return this.formatDate(this.primeiroDia)
      },
    },

    watch: {
      date (val) {
        this.dateFormatted = this.formatDate(this.date)
      },
    },

    created () {
      eventEmit.$on('update-dados', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados', this.handleUpdateDados)

      window.removeEventListener('resize', this.updateDynamicPadding)
    },

    mounted () {
      if (localStorage.tokencontrato) {
        eventEmit.$emit('atualizar_texto', 'Vendas')

        this.updateDynamicPadding()

        window.addEventListener('resize', this.updateDynamicPadding)

        this.usuarioIdentificado = true
      } else {
        this.usuarioIdentificado = false
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        this.$router.push('/login')
      }
    },

    methods: {
      updateDynamicPadding () {
        if (window.innerWidth > 1800) {
          this.dynamicPaddingTitulo = 'padding-right: 104rem !important'

          this.dynamicPaddingVendas1 = 'padding-right: 20rem !important'

          this.dynamicPaddingVendas2 = 'padding-right: 20rem !important'

          this.dynamicPaddingVendas3 = 'padding-right: 70rem !important'

          this.dynamicPaddingVendas4 = 'padding-right: 104rem !important'

          this.dynamicPaddingVendas5 = 'padding-right: 37rem !important'

          this.dynamicPaddingVendas6 = 'padding-right: 104rem !important'

          this.width = ''
        } else if (window.innerWidth > 1380 && window.innerWidth <= 1800) {
          this.dynamicPaddingTitulo = 'padding-right: 83rem !important'

          this.dynamicPaddingVendas1 = 'padding-right: 17rem !important'

          this.dynamicPaddingVendas2 = 'padding-right: 17rem !important'

          this.dynamicPaddingVendas3 = 'padding-right: 57rem !important'

          this.dynamicPaddingVendas4 = 'padding-right: 83rem !important'

          this.dynamicPaddingVendas5 = 'padding-right: 28.1rem !important'

          this.dynamicPaddingVendas6 = 'padding-right: 83rem !important'

          this.width = ''
        } else if (window.innerWidth > 380 && window.innerWidth < 680) {
          this.dynamicPaddingTitulo = 'padding-right: 9rem !important'

          this.dynamicPaddingVendas1 = 'padding-right: 9rem !important'

          this.dynamicPaddingVendas2 = 'padding-right: 9rem !important'

          this.dynamicPaddingVendas3 = 'padding-right: 9rem !important'

          this.dynamicPaddingVendas4 = 'padding-right: 9rem !important'

          this.dynamicPaddingVendas5 = 'padding-right: 9rem !important'

          this.dynamicPaddingVendas6 = 'padding-right: 9rem !important'

          this.width = '370'
        } else if (window.innerWidth > 680 && window.innerWidth < 1000) {
          this.dynamicPaddingTitulo = 'padding-right: 10rem !important'

          this.dynamicPaddingVendas1 = 'padding-right: 9rem !important'

          this.dynamicPaddingVendas2 = 'padding-right: 25rem !important'

          this.dynamicPaddingVendas3 = 'padding-right: 25rem !important'

          this.dynamicPaddingVendas4 = 'padding-right: 25rem !important'

          this.dynamicPaddingVendas5 = 'padding-right: 25rem !important'

          this.dynamicPaddingVendas6 = 'padding-right: 25rem !important'
        } else {
          this.dynamicPaddingTitulo = 'padding-right: 64rem !important'

          this.dynamicPaddingVendas1 = 'padding-right: 11rem !important'

          this.dynamicPaddingVendas2 = 'padding-right: 11rem !important'

          this.dynamicPaddingVendas3 = 'padding-right: 43rem !important'

          this.dynamicPaddingVendas4 = 'padding-right: 64rem !important'

          this.dynamicPaddingVendas5 = 'padding-right: 18rem !important'

          this.dynamicPaddingVendas6 = 'padding-right: 64rem !important'

          this.width = ''
        }
      },

      handleUpdateDados (primeiroDia, dataFinal, select, vendedores, areas, redes, supervisores, receita, segmento) {
        this.primeiroDia = primeiroDia
        this.date = dataFinal
        this.select = select
        this.supervisor = supervisores
        this.vendedores = vendedores
        this.areas = areas
        this.redes = redes
        this.segmento = segmento

        localStorage.setItem('updateDadosFiltros', true)
        localStorage.setItem('dataInicial', this.primeiroDia)
        localStorage.setItem('dataFinal', this.date)

        this.dataInicalAnterior()
        this.dataFinalAnterior()

        this.updateDate()
      },

      dataInicalAnterior () {
        const dataInicialAnterior = new Date(this.primeiroDia)
        dataInicialAnterior.setFullYear(dataInicialAnterior.getFullYear() - 1)

        const dataFormatada = dataInicialAnterior.toISOString().substr(0, 10)

        localStorage.setItem('dataInicialAnterior', dataFormatada)
      },

      dataFinalAnterior () {
        const dataFinalAnterior = new Date(this.date)
        dataFinalAnterior.setFullYear(dataFinalAnterior.getFullYear() - 1)

        const dataFormatadaAnterior = dataFinalAnterior.toISOString().substr(0, 10)

        localStorage.setItem('dataFinalAnterior', dataFormatadaAnterior)
      },

      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },

      async enableTexto (value) {
        if (this.codigoAtual === value && this.textoOrientacao) return

        this.codigoAtual = value
        this.carregandoTooltip = true
        this.textoOrientacao = ''

        try {
          const resposta = await Permissao.showOrientacaoIndicador(localStorage.username, localStorage.tokencontrato, value)

          if (resposta.data.status) {
            this.textoOrientacao = resposta.data.orientacao
            this.codigo = value
          }
        } catch (e) {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        } finally {
          this.carregandoTooltip = false
        }
      },

      async updateDate () {
        eventEmit.$emit('update-datas-vendas', this.primeiroDia, this.date, this.select, this.supervisor, this.vendedores, this.areas, this.redes, this.receita, this.segmento, [])
        eventEmit.$emit('update-dados-clientes-vendas', this.primeiroDia, this.date, this.select, this.supervisor, this.receita)

        this.valorFaturamento = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorIcmsst = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorDevolucao = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorFaturamentoAnoAnterior = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorIcmsstAnoAnterior = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorDevolucaoAnoAnterior = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

        this.loadingFaturamento = true
        this.loadingDevolucao = true
        this.loadingFaturamentoAnoAnterior = true
        this.loadingDevolucaoAnoAnterior = true
        this.loadingFaturamentoAcumulado = true
        this.loadingFaturamentoComparativo = true
        this.loadingPrecoMedioComparativo = true
        this.exibirLegenda = false
        this.exibirLegenda2 = false

        if (this.chartBarLinha.data) {
          this.chartBarLinha.destroy()
        }

        if (this.chartBarAcumuladoAnual.data) {
          this.chartBarAcumuladoAnual.destroy()
        }

        if (this.chartBarLinhaPrecoMedio.data) {
          this.chartBarLinhaPrecoMedio.destroy()
        }

        await Vendas3.showFatVendas(this.primeiroDia, this.date, this.select, this.supervisor, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.valorFaturamento = resposta.data.faturamento.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.valorIcmsst = resposta.data.icmsst.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          } else {
            if (resposta.data.text === 'Não há faturamento no período selecionado') {
              this.valorFaturamento = this.valorFaturamento.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
              this.showSnackbar('error', 3000, 'Não há faturamento no período selecionado')
            } else if (resposta.data.text === 'Empresa não encontrada') {
              this.showSnackbar('error', 3000, 'Empresa não encontrada')
            }
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.text === 'Datas não conferem') {
            this.error = e.data.text
            this.showSnackbar('error', 3000, e.data.msg)
          }
        }).finally(f => { this.loadingFaturamento = false })

        await Vendas3.showVendas3Devolucao(this.primeiroDia, this.date, this.select, this.supervisor, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.valorDevolucao = resposta.data.devolucao.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          } else if (resposta.data.text === 'Empresa não encontrada') {
            this.showSnackbar('error', 3000, 'Empresa não encontrada')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.text === 'Datas não conferem') {
            this.error = e.data.text
            this.showSnackbar('error', 3000, e.data.msg)
          }
        }).finally(f => { this.loadingDevolucao = false })

        await Vendas3.showFatMesAnoAnterior(this.primeiroDia, this.date, this.select, this.supervisor, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.valorFaturamentoAnoAnterior = resposta.data.faturamentoMesAnoAnterior.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.valorIcmsstAnoAnterior = resposta.data.icmsst.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          } else {
            if (resposta.data.text === 'Não há faturamento no período selecionado') {
              this.valorFaturamentoAnoAnterior = resposta.data.faturamentoMesAnoAnterior.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
              this.showSnackbar('error', 3000, 'Não há faturamento no período selecionado')
            } else if (resposta.data.text === 'Empresa não encontrada') {
              this.showSnackbar('error', 3000, 'Empresa não encontrada')
            }
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.text === 'Datas não conferem') {
            this.showSnackbar('error', 3000, e.data.msg)
          }
        }).finally(f => { this.loadingFaturamentoAnoAnterior = false })

        await Vendas3.showVendas3DevolucaoAnoAnterior(this.primeiroDia, this.date, this.select, this.supervisor, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.valorDevolucaoAnoAnterior = resposta.data.devolucao.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          } else if (resposta.data.text === 'Empresa não encontrada') {
            this.showSnackbar('error', 3000, 'Empresa não encontrada')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.text === 'Datas não conferem') {
            this.showSnackbar('error', 3000, e.data.msg)
          }
        }).finally(f => { this.loadingDevolucaoAnoAnterior = false })

        await Vendas3.showFat7MesesAnteriores(this.select, this.supervisor, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            const ctx = document.getElementById('myChart7').getContext('2d')

            this.chartBarLinha = new Chart(ctx, {
              type: 'bar',
              data: {
                labels: resposta.data.datasFaturamento,
                datasets: [
                  {
                    label: 'FaturamentoAnoAnterior',
                    data: resposta.data.faturamentoAnoAnterior,
                    backgroundColor: '#cadaed',
                    order: 2,
                  },
                  {
                    label: 'Faturamento',
                    data: resposta.data.faturamentoCorrente,
                    backgroundColor: '#4780b8',
                    order: 3,
                  },
                  {
                    label: 'Porcentagem',
                    data: resposta.data.valoresExibicao,
                    type: 'line',
                    borderColor: '#ed934f',
                    backgroundColor: 'transparent',
                    order: 1,
                    fill: false,
                    tension: 0,
                  },
                ],
              },
              options: {
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                  xAxes: [{
                    gridLines: {
                      display: false,
                    },
                  }],
                  yAxes: [{
                    ticks: {
                      min: 0,
                    },
                    gridLines: {
                      display: false,
                    },
                    display: false,
                  }],
                },
                low: 50,
                high: 5,
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                      if (tooltipItem.datasetIndex === 2) {
                        return resposta.data.porcentagem[tooltipItem.index].toFixed(2).toLocaleString('pt-BR') + '%'
                      } else if (tooltipItem.datasetIndex === 0) {
                        return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                      } else {
                        return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                      }
                    },
                    title: (tooltipItem) => {
                      if (tooltipItem[0].datasetIndex === 0) {
                        var ano = parseFloat(tooltipItem[0].xLabel.slice(-2)) - 1
                        var mes = tooltipItem[0].xLabel.slice(0, -2)

                        tooltipItem[0].xLabel = mes + ano

                        return tooltipItem[0].xLabel
                      } else if (tooltipItem[0].datasetIndex === 2) {
                        tooltipItem[0].xLabel = 'Variação'

                        return tooltipItem[0].xLabel
                      } else {
                        return tooltipItem[0].xLabel
                      }
                    },
                  },
                },
              },
            })
          } else if (resposta.data.msg === 'Não há faturamento lançado para comparação nos ultimos 7 meses') {
            this.text = resposta.data.text

            if (this.chartBarLinha.data) {
              this.chartBarLinha.destroy()
            }

            this.showSnackbar('error', 3000, resposta.data.text)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.text === 'Contrato não encontrado') {
            this.error = e.data.text
            this.showSnackbar('error', 3000, e.data.text)
          }
        }).finally(f => {
          this.loadingFaturamentoComparativo = false

          this.exibirLegenda = true
        })

        await Vendas3.showFat7MesesAnteriores(this.select, this.supervisor, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            const ctx = document.getElementById('myChart9').getContext('2d')

            this.chartBarAcumuladoAnual = new Chart(ctx, {
              plugins: [ChartDataLabels],
              type: 'bar',
              data: {
                labels: ['Ano Corrente'],
                datasets: [
                  {
                    label: 'FaturamentoAnoAnterior',
                    data: [resposta.data.somatorioAnoAnterior],
                    backgroundColor: '#cadaed',
                    order: 1,
                  },
                  {
                    label: 'Faturamento',
                    data: [resposta.data.somatorioAnoCorrente],
                    backgroundColor: '#4780b8',
                    order: 2,
                  },
                ],
              },
              options: {
                plugins: {
                  datalabels: {
                    display: true,
                    align: 'top',
                    color: function (context) {
                      if (context.dataset.label !== 'Porcentagem') {
                        return '#000000'
                      } else {
                        return 'transparent'
                      }
                    },
                    font: {
                      size: 11,
                    },
                    formatter: (value) => {
                      return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                    },
                  },
                },
                scales: {
                  xAxes: [{
                    gridLines: {
                      display: false,
                    },
                  }],
                  yAxes: [{
                    ticks: {
                      min: 0,
                    },
                    gridLines: {
                      display: false,
                    },
                    display: false,
                  }],
                },
                responsive: true,
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                      return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                    },
                    title: (tooltipItem) => {
                      if (tooltipItem[0].datasetIndex === 0) {
                        tooltipItem[0].xLabel = 'Ano Anterior'

                        return tooltipItem[0].xLabel
                      } else {
                        return tooltipItem[0].xLabel
                      }
                    },
                  },
                },
              },
            })
          } else if (resposta.data.msg === 'Não há faturamento lançado para comparação nos ultimos 7 meses') {
            this.text = resposta.data.text

            if (this.chartBarAcumuladoAnual.data) {
              this.chartBarAcumuladoAnual.destroy()
            }

            this.showSnackbar('error', 3000, resposta.data.text)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.text === 'Contrato não encontrado') {
            this.error = e.data.text
            this.showSnackbar('error', 3000, e.data.text)
          }
        }).finally(f => { this.loadingFaturamentoAcumulado = false })

        await Vendas3.showPrecoMedio7MesesAnteriores(this.select, this.supervisor, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            const ctx = document.getElementById('precoMedioMesesAnteriores').getContext('2d')

            this.chartBarLinhaPrecoMedio = new Chart(ctx, {
              type: 'bar',
              data: {
                labels: resposta.data.datasPrecoMedio,
                datasets: [
                  {
                    label: 'PrecoMedioAnoAnterior',
                    data: resposta.data.precoMedioAnoAnterior,
                    backgroundColor: '#cadaed',
                    order: 2,
                  },
                  {
                    label: 'PrecoMedio',
                    data: resposta.data.precoMedioCorrente,
                    backgroundColor: '#4780b8',
                    order: 3,
                  },
                  {
                    label: 'Porcentagem',
                    data: resposta.data.valoresExibicao,
                    type: 'line',
                    borderColor: '#ed934f',
                    backgroundColor: 'transparent',
                    order: 1,
                    fill: false,
                    tension: 0,
                  },
                ],
              },
              options: {
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                  xAxes: [{
                    gridLines: {
                      display: false,
                    },
                  }],
                  yAxes: [{
                    ticks: {
                      min: 0,
                    },
                    gridLines: {
                      display: false,
                    },
                    display: false,
                  }],
                },
                low: 50,
                high: 5,
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                      if (tooltipItem.datasetIndex === 2) {
                        return resposta.data.porcentagem[tooltipItem.index].toFixed(2).toLocaleString('pt-BR') + '%'
                      } else if (tooltipItem.datasetIndex === 0) {
                        return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                      } else {
                        return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                      }
                    },
                    title: (tooltipItem) => {
                      if (tooltipItem[0].datasetIndex === 0) {
                        var ano = parseFloat(tooltipItem[0].xLabel.slice(-2)) - 1
                        var mes = tooltipItem[0].xLabel.slice(0, -2)

                        tooltipItem[0].xLabel = mes + ano

                        return tooltipItem[0].xLabel
                      } else if (tooltipItem[0].datasetIndex === 2) {
                        tooltipItem[0].xLabel = 'Variação'

                        return tooltipItem[0].xLabel
                      } else {
                        return tooltipItem[0].xLabel
                      }
                    },
                  },
                },
              },
            })
          } else if (resposta.data.msg === 'Não há faturamento lançado para comparação nos ultimos 7 meses') {
            this.text = resposta.data.text

            if (this.chartBarLinhaPrecoMedio.data) {
              this.chartBarLinhaPrecoMedio.destroy()
            }

            this.showSnackbar('error', 3000, resposta.data.text)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.text === 'Contrato não encontrado') {
            this.error = e.data.text
            this.showSnackbar('error', 3000, e.data.text)
          }
        }).finally(f => {
          this.loadingPrecoMedioComparativo = false

          this.exibirLegenda2 = true
        })
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }
</script>

<style scoped>
  #cardDashbord {
    border-radius: 14px;
    border: 1px solid rgba(0,0,0,0.05);
    box-shadow:
      0 2px 4px rgba(0,0,0,0.08),
      0 6px 12px rgba(0,0,0,0.06),
      0 12px 24px rgba(0,0,0,0.04);
    transition: all 0.25s ease;
    transform: translateY(-3px);
    box-shadow:
      0 4px 8px rgba(0,0,0,0.10),
      0 12px 22px rgba(0,0,0,0.09),
      0 20px 32px rgba(0,0,0,0.06);
  }

  .card-header-dashbord {
    background-color: #ffffff;
    padding: 14px 18px;
    font-weight: 600;
    font-size: 14px;
    color: black;
    border-bottom: 1px solid #b7b1b1;
    border-radius: 14px 14px 0 0;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #faturamentoVendas3 {
      font-size: 14px;
      margin: -1rem 0 0 -22rem;
    }

    #componentevlrFatVendas3 {
      margin: -1rem 0 0 1rem !important
    }

    #iconInformationAcumuladoAnualComparativoVendas3 {
      margin: -6rem 0 0.2rem 29rem;
    }

    #faturamentoMesAnoAnteriorVendas3 {
      font-size: 14px;
      margin: -5.7rem 0 0 13rem;
    }

    #componentevlrFatMesAnteriorVendas3 {
      margin: -1rem 0 0 -2rem;
    }

    #vendas7MesesAnterioresIdsVendas3 {
      margin: 1rem 0 0 2rem;
    }

    #textoPrincipaisClientesVendas3 {
      width: 100%;
      font-size: 12px;
    }

    #iconVendas3 {
      margin: -5rem 0 0 0rem;
    }

    #iconInformationAcumuladoAnualVendas3 {
      margin: 0 0 0 -0.5rem;
    }

    #componetenPrecoMedioVendas3 {
      margin: 5rem 0 0 -1rem
    }

    #componenteDevolucao {
      margin: -2rem 0 0 0
    }

    #listItemFaturamentoVendas {
      margin: -1rem 0 0 -1rem
    }

    #listItemPrincipaisClientes {
      margin: -1rem 0 0 -1rem
    }

    #listItemGrupoItens {
      margin: -1rem 0 0 -1rem
    }

    #listItemEvolucaoVendas {
      margin: -1rem 0 0 -1rem
    }

    #listItemEvolucaoVolumeVendas {
      margin: -1rem 0 0 -1rem
    }
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 1000px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #faturamentoVendas3 {
      font-size: 18px;
      margin: 1rem 0 0 -4rem;
    }

    #componentevlrFatVendas3 {
      margin: 0 0 0 10rem;
    }

    #iconInformationAcumuladoAnualVendas3 {
      margin: 0 0 0 -25rem;
    }

    #iconInformationAcumuladoAnualComparativoVendas3 {
      margin: 0 0 0 -25rem;
    }

    #faturamentoMesAnoAnteriorVendas3 {
      font-size: 18px;
      margin: 1rem 0 0 2rem;
    }

    #componentevlrFatMesAnteriorVendas3 {
      margin: 0 0 0 6rem
    }
  }

  @media screen
  and (min-width : 1380px)
  and (max-width : 1600px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #faturamentoVendas3 {
      margin: 0 0 0 5rem !important;
    }

    #componentevlrFatVendas3 {
      margin: 0 0 0 4rem;
    }

    #iconInformationAcumuladoAnualVendas3 {
      margin: 0 0 0 10rem;
    }

    #componentevlrFatMesAnteriorVendas3 {
      margin: auto;
    }
  }

  @media screen
  and (min-width: 1601px) {
    #faturamentoVendas3 {
      margin: 0 0 0 -3rem !important;
    }

    #componentevlrFatVendas3 {
      margin: 0 0 0 4rem;
    }

    #iconInformationAcumuladoAnualVendas3 {
      margin: 0 0 0 4.7rem;
    }

    #iconInformationAcumuladoAnualComparativoVendas3 {
      margin: 0 0 0 4rem;
    }

    #componentevlrFatMesAnteriorVendas3 {
      margin: auto;
    }

    #textoEvolucaoVendaVendas3 {
      margin: 0 0 0 5.45rem
    }

    #iconInformationEvolucaoVolumeVendas3 {
      margin: 0 0 0 5.4rem;
    }
  }
</style>

<style lang="sass">
  #faturamentoVendas3
    font-size: 16px
    display: grid
    align-items: center
    margin: 0.7rem 0 0 -5rem
    font-weight: bold

  #componentevlrFatVendas3
    margin: 0 0 0 4rem

  #faturamentoMesAnoAnteriorVendas3
    font-size: 16px
    display: grid
    align-items: center
    margin: 0.7rem 0 0 3rem
    font-weight: bold

  #faturamentoAcumuladoAnualVendas3
    font-size: 16px
    display: grid
    align-items: center
    margin: 0.7rem 0 0 3rem
    font-weight: bold

  #comparativoFaturamentoVendas3
    font-size: 16px
    display: grid
    align-items: center
    margin: 0rem 0 0 3rem
    font-weight: bold

  #comparativoPrecoMedioVendas3
    font-size: 16px
    display: grid
    align-items: center
    margin: 0.7rem 0 0 3rem
    font-weight: bold

  #componentevlrFatMesAnteriorVendas3
    margin: 0rem 0 0 0rem

  #btnRefazerVendas
    margin: 1.5rem auto

  .textoAcumuladoAnualVendas3
    margin: 0 0 1rem 1rem

  #iconInformationAcumuladoAnualComparativoVendas3
    margin: 0 0 0.2rem 1rem

  #textoEvolucaoVendaVendas3
    margin: 0 0 0 1rem

  #legendaVendas
    font-size: 12px

  #listItemFaturamentoVendas
    margin: -2rem 0 0 -1rem

  #componenteFaturamento
    margin: -3rem 0 0 0

  #componenteDevolucao
    margin: -3rem 0 0 0

  #listItemPrincipaisClientes
    margin: -2rem 0 0 -1rem

  #listItemGrupoItens
    margin: -2rem 0 0 -1rem

  #componenteGrupoVendas
    margin: -2rem 0 0 0rem

  #listItemEvolucaoVendas
    margin: -2rem 0 0 -1rem

  #listItemEvolucaoVolumeVendas
    margin: -2rem 0 0 -1rem

  .highlighted-item
    background-color: #2863af
    padding: 16px
    color: white
    margin: -1rem 0 0 0

</style>
